import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject, input } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { Store } from '@ngrx/store';

import { UiManagerActions } from '../../ui-manager/ui-manager.actions';
import { IUiRootState } from '../../ui-manager/ui-manager.state';
import { UiStates } from '../../ui-manager/ui-states.enum';
import { MarketHelpTrackingService } from './market-help-tracking.service';

@Component({
    selector: 'ms-market-help-toggle',
    templateUrl: './market-help-toggle.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, IconCustomComponent, DsButtonIcon],
})
export class MarketHelpToggleComponent {
    private marketHelpTrackingService = inject(MarketHelpTrackingService);
    private store = inject<Store<IUiRootState>>(Store);

    @Input() optionGroup: EventOptionGroup;
    @Input() selected: boolean;
    readonly event = input.required<EventModel>();
    @Output() selectedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    toggleHelp(event: MouseEvent): void {
        event.stopPropagation();
        event.preventDefault();

        this.store.dispatch(UiManagerActions.removeState({ state: UiStates.MarketSubTypeTooltipShown }));
        this.selected = !this.selected;
        this.selectedChange.next(this.selected);

        this.marketHelpTrackingService.trackToggle(this.optionGroup, this.event().league.id, this.event().sport.id);
    }
}
